import React, { useEffect } from "react"; 
import AOS from "aos";
import { a } from "react-router-dom";
import "aos/dist/aos.css"; // Ensure AOS styles are imported
import "./footer.css";

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <>
            {/* <!-- Contact Form --> */}
         <section className="container"  id="contact-form">
          <div className="row">
            <div className="lets-form">
           
            
            
            <div className="col-lg-6 col-md-12 " data-aos="fade-up" data-aos-delay="0">
              <div className="left-section">
                <h1>Let's <span>Talk!</span></h1>
              </div>

            </div>
            <div className="col-lg-6 col-md-12" data-aos="fade-up" data-aos-delay="100">
            
                <div className="form-section">
        <form id="contactForm">
            <label for="name">Name</label>
            <input type="text" id="name" name="name" placeholder="Full Name" required/>

            <label for="email">Email</label>
            <input type="email" id="email" name="email" placeholder="name@gmail.com" required/>

            <label for="message">Message</label>
            <textarea id="message" name="message" placeholder="Write your message" required></textarea>

            <button className="form-btn" type="submit">Submit</button>
        </form>
    </div>

            </div>
            </div>

          </div>

         </section>
       
    {/* <!-- Footer --> */}
    <footer className="footer-section footer-radius text-white py-5">
        <div className="container">
          <div className="row ">
            {/* <!-- Contact Info --> */}
            <div className="col-lg-6 col-md-12 mb-4">
              <div className="footer-transprnt" data-aos="fade-up" data-aos-delay="0">

              
              <div className="contact-info mb-3">
                <i className="fa-regular fa-envelope"></i>
                <p>support@codeqlik.com</p>
              </div>
            </div>
            <div className="footer-transprnt" data-aos="fade-up" data-aos-delay="100">
              <div className="contact-info mb-3">
                <i className="fas fa-phone me-2"></i>
                <p className="call-text">
                <a href="tel:+91-8949687368 " rel="nofollow">+91-8949687368 </a></p>
                
              </div>
            </div>
            <div className="footer-transprnt" data-aos="fade-up" data-aos-delay="200">
              <div className="contact-info address">
                <i className="fas fa-map-marker-alt me-2"></i>
                <p>
                  CodeQlik - IT Solutions, 301, 3rd Floor, 244-245, Dhruv Marg, Tilak Nagar, near Baskin-Robbins, Gurunanakpura, Raja Park, Jaipur, Rajasthan 302004
                </p>
              </div>
            </div>
            </div>
            <div className="col-lg-1   ">

            </div>
            {/* <!-- Menu --> */}
            <div className="col-lg-2 col-md-6  mb-4" data-aos="fade-up" data-aos-delay="0">
              <h5 className="mb-3 text-start menu-header">Menu</h5>
              <ul className="list-unstyled text-start">
                <li><a href="/" className="text-white text-decoration-none">Home</a></li>
                <li><a href="/about" className="text-white text-decoration-none">About</a></li>
                <li><a href="/servicedetail" className="text-white text-decoration-none">Services</a></li>
                <li><a href="/projects" className="text-white text-decoration-none">Projects</a></li>
                <li><a href="/blog" className="text-white text-decoration-none">Blog</a></li>
                <li><a href="/reviews" className="text-white text-decoration-none">Review</a></li>
                <li><a href="/contact" className="text-white text-decoration-none">Contact</a></li>
                <li><a href="/events" className="text-white text-decoration-none">Events</a></li>
              </ul>
            </div>
            {/* <!-- Services --> */}
            <div className="col-lg-3 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
              <h5 className="mb-3 text-start menu-header">Services</h5>
              <ul className="list-unstyled text-start">
                <li><a href="/servicedetail" className="text-white text-decoration-none">Website Development Services</a></li>
                <li><a href="/servicedetail" className="text-white text-decoration-none">Mobile Application Development</a></li>
                <li><a href="/servicedetail" className="text-white text-decoration-none">Digital Marketing Solutions</a></li>
                <li><a href="/servicedetail" className="text-white text-decoration-none">Content Marketing</a></li>
                <li><a href="/servicedetail" className="text-white text-decoration-none">Figma Design Services</a></li>
                <li><a href="/servicedetail" className="text-white text-decoration-none">Software Development Services</a></li>
              </ul>
            </div>
          </div>
          
        </div>
      </footer>
      <footer className="footer-radius">
       <div className="row mt-4 text-center" data-aos="fade-up" data-aos-delay="100">
        <div className="footer-social-text">
          <h5>Follow us:</h5>
          <div className="social-icons d-flex justify-content-center gap-3">
            <a href="#" className="text-white"><i className="fab fa-facebook-f"></i></a>
            <a href="#" className="text-white"><i className="fab fa-twitter"></i></a>
            <a href="#" className="text-white"><i className="fab fa-linkedin-in"></i></a>
            <a href="#" className="text-white"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
      </div>
    </footer>
<hr/>
    <footer>
        <p>&copy; 2025 CodeQlik. All rights reserved.</p>
    </footer>

    </>
  )
}

export default Footer